import React, { useContext } from 'react'
import { StateContext } from '../../services/StateService'
import SelectorsContainer from '../../components/SelectorsContainer'
import '../../css/ProductSelector.scss'

const ProductSelector = ({ prodOptButtonRef, handleProductSelectorRequest }) => {
    const { dispatch, selectedOptions } = useContext(StateContext)

    /* istanbul ignore next */
    const handleReset = () => {
        dispatch({
            type: 'pdp_set_selected_options',
            payload: { initialState: true }
        })
        dispatch({
            type: 'pdp_set_product_options',
            payload: {
                productOptions: [],
                moreOptions: { totalSelected: 0 },
                endpoint: ''
            }
        })
        dispatch({ type: 'pdp_set_loading_CCWTBScript', payload: false })
        dispatch({
            type: 'set_AJAX_errors',
            payload: {
                productOptionsAjaxError: false,
                selectorsAjaxError: false
            }
        })
    }

    const clearAllOption = () => {
        let clearAllFlag = false
        Object.keys(selectedOptions?.options)?.map((key) => {
            const selector = selectedOptions.options[key]
            if (selector?.values?.length > 1) {
                clearAllFlag = true
            }
            return clearAllFlag
        })
        return clearAllFlag
    }

    return (
        <div className="sps2-pdp_pSelector--container">
            {selectedOptions?.totalSelectors > 0 && (
                <SelectorsContainer
                    key="pSelector_x"
                    handleReset={handleReset}
                    prodOptButtonRef={prodOptButtonRef}
                    handleProductSelectorRequest={handleProductSelectorRequest}
                    clearAll={clearAllOption()}
                />
            )}
        </div>
    )
}

export default ProductSelector
